module.exports = __webpack_public_path__ + "img/Pic_Bg_Fz_SRX.67f91157.png";